export default __webpack_public_path__ + "static/5-860326f87114c3fa2e3c66d566b7204e.jpg";